import { getImageFromAssetFolder } from "../../../utils/assets";

const testimonials = [
  {
    avatar: getImageFromAssetFolder("avatar.jpg"),
    name: "Aman Sharma",
    exam: "UPSC",
    text: "This platform completely changed how I study. The quiz analysis helped me improve my weak areas quickly.",
  },
  {
    avatar: getImageFromAssetFolder("avatar.jpg"),
    name: "Priya Mehta",
    exam: "NEET",
    text: "The detailed syllabus tracking helped me plan my prep effectively. Super useful!",
  },
  {
    avatar: getImageFromAssetFolder("avatar.jpg"),
    name: "Rohit Verma",
    exam: "JEE Advanced",
    text: "Quality quizzes with analytics gave me real-time feedback. I’m much more confident now.",
  },
  {
    avatar: getImageFromAssetFolder("avatar.jpg"),
    name: "Sanya Kapoor",
    exam: "CAT",
    text: "The interface is smooth and the insights are exactly what I needed. Highly recommended!",
  },
  {
    avatar: getImageFromAssetFolder("avatar.jpg"),
    name: "Kunal Joshi",
    exam: "SSC CGL",
    text: "With daily quizzes and clear performance breakdowns, I can easily track my growth.",
  },
  {
    avatar: getImageFromAssetFolder("avatar.jpg"),
    name: "Ayesha Siddiqui",
    exam: "GATE",
    text: "From topic-wise quizzes to advanced analytics, this app covers everything.",
  },
  {
    avatar: getImageFromAssetFolder("avatar.jpg"),
    name: "Nikhil Desai",
    exam: "CLAT",
    text: "Insightful analytics and sleek design. It’s like having a smart coach with you!",
  },
  {
    avatar: getImageFromAssetFolder("avatar.jpg"),
    name: "Meera Nair",
    exam: "Bank PO",
    text: "I love how the app simplifies my daily targets and progress tracking.",
  },
];

const Testimonials = () => {
  return (
    <div
      className="p-16 rounded-xl flex flex-col items-center"
      style={{ background: "#f2f8fd" }}
    >
      <h3 className="text-center text-2xl font-semibold" style={{ margin: 0 }}>
        What Students Say
      </h3>
      <p className="text-center text-gray-600" style={{ margin: 0 }}>
        Real feedback from real learners across exams
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-8 w-full">
        {testimonials.map((t, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow p-4 flex flex-col items-start"
          >
            <p className="text-sm text-gray-700 mb-4">"{t.text}"</p>
            <div className="flex items-center mt-auto">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-10 h-10 rounded-full mr-3"
              />
              <div>
                <p className="text-sm font-semibold">{t.name}</p>
                <p className="text-xs text-gray-500">Preparing for {t.exam}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
